/**
 * The Crisp workspace this app's chat belongs to.
 *
 * Shared by the web widget loader (`routes/support`) and the native SDK's `configure()` call, so
 * the two platforms can never drift onto different workspaces.
 *
 * This is a public, client-side identifier — Crisp embeds it in the `<script>` tag every web
 * visitor downloads — so it is not a secret and deliberately does not live in `.env.schema`.
 */
export const CRISP_WEBSITE_ID = "70b8db6e-02ce-4ca4-a0c6-dafe150be2f1";
